import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "../styles/UserLink.module.css";

const UserLink = ({ userId, userName, className, style, onClick }) => {
  return (
    <Link
      to={`/u/${userId}`}
      className={`${styles.userLink} ${className}`}
      style={style}
      onClick={onClick}
    >
      {userName}
    </Link>
  );
};

UserLink.propTypes = {
  userId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

UserLink.defaultProps = {
  className: "",
  style: {},
  onClick: () => {},
};

export default UserLink;
